import { Bell, Filter } from 'lucide-react';

const FG = '#F5F1FA';
const MUTED = '#A99FB8';
const SURFACE2 = '#140C20';
const SURFACE = '#1B1029';
const VIOLET = '#6D28D9';
const VIOLET_LIGHT = '#A855F7';
const CHAMPAGNE = '#E8B96A';
const BORDER = 'rgba(255,255,255,0.08)';

const FILTER_GROUPS = [
  {
    label: 'STATUS',
    items: [
      { label: 'Não lidas', active: true },
      { label: 'Todas', active: false },
      { label: 'Lidas', active: false },
    ],
  },
  {
    label: 'TRIBUNAL',
    items: [
      { label: 'Todos', active: false },
      { label: 'TJRS', active: false },
      { label: 'TJMG', active: false },
    ],
  },
];

const CARDS = [
  {
    tribunal: 'TJRS',
    date: '16/06/2026',
    title: 'Intimação',
    cnj: '0001234-56.2025.8.21.0010',
    trecho: 'Fica intimada a parte requerida para apresentar contestação no prazo legal.',
  },
  {
    tribunal: 'TJRS',
    date: '15/06/2026',
    title: 'Intimação',
    cnj: '0007891-12.2024.8.21.0001',
    trecho: 'Designada audiência de conciliação para o dia 05/07/2026 às 14h.',
  },
];

export function IntimacoesMockup() {
  return (
    <div
      style={{
        width: '100%',
        borderRadius: 16,
        overflow: 'hidden',
        border: `1px solid ${BORDER}`,
        background: SURFACE2,
        boxShadow:
          '0 0 0 1px rgba(109,40,217,0.15), 0 32px 80px rgba(0,0,0,0.55), 0 8px 24px rgba(109,40,217,0.12)',
        fontFamily: "'Hanken Grotesk', sans-serif",
      }}
    >
      {/* Titlebar */}
      <div
        style={{
          background: 'rgba(20,12,32,0.98)',
          borderBottom: `1px solid rgba(255,255,255,0.07)`,
          padding: '12px 18px',
          display: 'flex',
          alignItems: 'center',
          gap: 14,
        }}
      >
        <div style={{ display: 'flex', gap: 7, flexShrink: 0 }}>
          {['#FF5F56', '#FFBD2E', '#27C93F'].map((c) => (
            <span
              key={c}
              style={{
                width: 11,
                height: 11,
                borderRadius: '50%',
                background: c,
                opacity: 0.75,
                display: 'inline-block',
              }}
            />
          ))}
        </div>
        <Bell size={13} color={CHAMPAGNE} strokeWidth={2} />
        <span style={{ fontSize: 12, fontWeight: 600, color: FG }}>
          Intimações
        </span>
        <span
          style={{
            marginLeft: 'auto',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            fontSize: 10,
            fontWeight: 600,
            color: CHAMPAGNE,
            background: 'rgba(232,185,106,0.1)',
            border: '1px solid rgba(232,185,106,0.22)',
            borderRadius: 20,
            padding: '2px 8px',
          }}
        >
          <span
            style={{
              width: 5,
              height: 5,
              borderRadius: '50%',
              background: CHAMPAGNE,
              boxShadow: `0 0 6px ${CHAMPAGNE}99`,
              display: 'inline-block',
            }}
          />
          2 não lidas
        </span>
      </div>

      {/* 3 colunas */}
      <style>{`
        @media (max-width: 600px) {
          .intim-layout { flex-direction: column !important; }
          .intim-filters { display: none !important; }
          .intim-list { width: 100% !important; border-right: none !important; border-bottom: 1px solid rgba(255,255,255,0.08) !important; }
          .intim-detail { padding: 12px !important; }
        }
      `}</style>
      <div className="intim-layout" style={{ display: 'flex', minHeight: 300 }}>
        {/* Rail de filtros */}
        <div
          className="intim-filters"
          style={{
            width: 130,
            flexShrink: 0,
            borderRight: `1px solid ${BORDER}`,
            background: 'rgba(20,12,32,0.5)',
            padding: '14px 0',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              padding: '0 12px 10px',
              borderBottom: `1px solid ${BORDER}`,
              marginBottom: 12,
            }}
          >
            <Filter size={11} color={MUTED} strokeWidth={2} />
            <span
              style={{
                fontSize: 9,
                fontWeight: 700,
                letterSpacing: '0.12em',
                textTransform: 'uppercase' as const,
                color: MUTED,
              }}
            >
              Filtros
            </span>
          </div>

          {FILTER_GROUPS.map((g) => (
            <div key={g.label} style={{ marginBottom: 14, padding: '0 12px' }}>
              <p
                style={{
                  fontSize: 9,
                  fontWeight: 700,
                  letterSpacing: '0.12em',
                  textTransform: 'uppercase' as const,
                  color: MUTED,
                  margin: '0 0 6px',
                }}
              >
                {g.label}
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {g.items.map((item) => (
                  <div
                    key={item.label}
                    style={{
                      fontSize: 11,
                      fontWeight: item.active ? 600 : 400,
                      color: item.active ? VIOLET_LIGHT : MUTED,
                      padding: '4px 8px',
                      borderRadius: 5,
                      background: item.active
                        ? 'rgba(168,85,247,0.12)'
                        : 'transparent',
                      cursor: 'default',
                    }}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Lista de cards */}
        <div
          className="intim-list"
          style={{
            width: 220,
            flexShrink: 0,
            borderRight: `1px solid ${BORDER}`,
            display: 'flex',
            flexDirection: 'column',
            gap: 0,
          }}
        >
          {CARDS.map((card, i) => (
            <div
              key={i}
              style={{
                padding: '12px 14px',
                borderBottom: `1px solid ${BORDER}`,
                background: i === 0 ? 'rgba(168,85,247,0.06)' : 'transparent',
                cursor: 'default',
                borderLeft: i === 0 ? `2px solid ${VIOLET_LIGHT}` : '2px solid transparent',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: 5,
                }}
              >
                <span
                  style={{
                    fontSize: 9,
                    fontWeight: 700,
                    color: VIOLET_LIGHT,
                    background: 'rgba(168,85,247,0.1)',
                    border: '1px solid rgba(168,85,247,0.2)',
                    borderRadius: 4,
                    padding: '1px 6px',
                  }}
                >
                  {card.tribunal}
                </span>
                <span style={{ fontSize: 9, color: MUTED }}>{card.date}</span>
              </div>
              <p
                style={{
                  fontSize: 11,
                  fontWeight: 600,
                  color: FG,
                  margin: '0 0 2px',
                }}
              >
                {card.title} &middot; <span style={{ fontWeight: 400, color: MUTED, fontSize: 10 }}>{card.cnj}</span>
              </p>
              <p
                style={{
                  fontSize: 10,
                  color: MUTED,
                  margin: 0,
                  lineHeight: 1.4,
                  overflow: 'hidden',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical' as const,
                }}
              >
                {card.trecho}
              </p>
            </div>
          ))}
        </div>

        {/* Painel de detalhe */}
        <div className="intim-detail" style={{ flex: 1, padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          {/* Header detalhe */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <span
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                  color: VIOLET_LIGHT,
                  background: 'rgba(168,85,247,0.1)',
                  border: '1px solid rgba(168,85,247,0.2)',
                  borderRadius: 4,
                  padding: '2px 8px',
                }}
              >
                TJRS
              </span>
              <span style={{ fontSize: 10, color: MUTED }}>Entrega: 16/06/2026</span>
            </div>
            <p
              style={{
                fontSize: 10,
                fontWeight: 500,
                color: MUTED,
                margin: 0,
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              0001234-56.2025.8.21.0010
            </p>
            <p
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: FG,
                margin: '3px 0 0',
              }}
            >
              Ação de Indenização por Danos Morais
            </p>
          </div>

          {/* Divider */}
          <div style={{ height: 1, background: BORDER }} />

          {/* Tarefas geradas */}
          <div>
            <p
              style={{
                fontSize: 9,
                fontWeight: 700,
                letterSpacing: '0.12em',
                textTransform: 'uppercase' as const,
                color: MUTED,
                margin: '0 0 8px',
              }}
            >
              Tarefas geradas
            </p>
            <div
              style={{
                background: SURFACE,
                border: `1px solid ${BORDER}`,
                borderRadius: 8,
                padding: '10px 12px',
                display: 'flex',
                flexDirection: 'column',
                gap: 6,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span
                  style={{
                    fontSize: 10,
                    fontWeight: 600,
                    color: VIOLET_LIGHT,
                    background: 'rgba(168,85,247,0.1)',
                    border: '1px solid rgba(168,85,247,0.2)',
                    borderRadius: 4,
                    padding: '2px 7px',
                  }}
                >
                  Protocolo
                </span>
              </div>
              <div style={{ height: 1, background: BORDER }} />
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: 10, color: MUTED }}>Prazo fatal</span>
                <span
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: '#F87171',
                  }}
                >
                  22/06/2026
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
